 import { useState, useEffect } from 'react';
import { Shield, Sparkles, Users, Settings, ExternalLink, Plus } from 'lucide-react';

export default function Mari() {
  const [stats, setStats] = useState({
    servers: 0,
    users: 0,
    commands: 0
  });

  useEffect(() => {
    const animateStats = () => {
      const duration = 1500;
      const steps = 50;
      const interval = duration / steps;
      
      const targetServers = 14;
      const targetUsers = 600;
      const targetCommands = 30;
      
      let step = 0;
      const timer = setInterval(() => {
        step++;
        const progress = step / steps;
        
        setStats({
          servers: Math.floor(targetServers * progress),
          users: Math.floor(targetUsers * progress),
          commands: Math.floor(targetCommands * progress)
        });
        
        if (step >= steps) {
          clearInterval(timer);
          setStats({
            servers: targetServers,
            users: targetUsers,
            commands: targetCommands
          });
        }
      }, interval);
      
      return () => clearInterval(timer);
    };

    animateStats();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{
      background: 'linear-gradient(180deg, #0a0a0a 0%, #1a1a1a 100%)'
    }}>
      <div className="w-full max-w-md">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full mb-4" style={{
            background: 'linear-gradient(135deg, #F8D2AD 0%, #e8c29d 100%)',
            boxShadow: '0 8px 32px rgba(248, 210, 173, 0.3)'
          }}>
            <img 
              src="https://maribot.xyz/favicon.ico" 
              alt="Mari" 
              className="w-14 h-14 rounded-full"
            />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">Mari</h1>
          <p className="text-sm" style={{ color: '#888' }}>
            Bot multifuncional para Discord
          </p>
        </div>

        {/* Stats Card */}
        <div className="rounded-2xl p-6 mb-4" style={{
          backgroundColor: '#151515',
          border: '1px solid #222'
        }}>
          <div className="grid grid-cols-3 gap-6">
            <div className="text-center">
              <div className="text-2xl font-bold text-white mb-1">
                {stats.servers}
              </div>
              <div className="text-xs" style={{ color: '#888' }}>
                Servidores
              </div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-white mb-1">
                {stats.users}+
              </div>
              <div className="text-xs" style={{ color: '#888' }}>
                Membros
              </div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-white mb-1">
                {stats.commands}+
              </div>
              <div className="text-xs" style={{ color: '#888' }}>
                Comandos
              </div>
            </div>
          </div>
        </div>

        {/* Features */}
        <div className="rounded-2xl p-6 mb-4" style={{
          backgroundColor: '#151515',
          border: '1px solid #222'
        }}>
          <h2 className="text-sm font-semibold text-white mb-4" style={{ letterSpacing: '0.05em' }}>
            RECURSOS
          </h2>
          <div className="space-y-3">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{
                backgroundColor: '#F8D2AD20'
              }}>
                <Shield className="w-4 h-4" style={{ color: '#F8D2AD' }} />
              </div>
              <span className="text-sm" style={{ color: '#aaa' }}>Moderação avançada</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{
                backgroundColor: '#F8D2AD20'
              }}>
                <Sparkles className="w-4 h-4" style={{ color: '#F8D2AD' }} />
              </div>
              <span className="text-sm" style={{ color: '#aaa' }}>Automação inteligente</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{
                backgroundColor: '#F8D2AD20'
              }}>
                <Users className="w-4 h-4" style={{ color: '#F8D2AD' }} />
              </div>
              <span className="text-sm" style={{ color: '#aaa' }}>Entretenimento completo</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{
                backgroundColor: '#F8D2AD20'
              }}>
                <Settings className="w-4 h-4" style={{ color: '#F8D2AD' }} />
              </div>
              <span className="text-sm" style={{ color: '#aaa' }}>Ferramentas úteis</span>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="grid grid-cols-2 gap-3">
          <a
            href="https://maribot.xyz"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 py-3 rounded-xl font-medium text-sm transition-all hover:opacity-80"
            style={{
              backgroundColor: '#151515',
              border: '1px solid #F8D2AD',
              color: '#F8D2AD'
            }}
          >
            <ExternalLink className="w-4 h-4" />
            Website
          </a>
          <a
            href="https://discord.com/oauth2/authorize?client_id=1452884254546727033"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 py-3 rounded-xl font-medium text-sm transition-all hover:opacity-90"
            style={{
              backgroundColor: '#F8D2AD',
              color: '#0a0a0a'
            }}
          >
            <Plus className="w-4 h-4" />
            Adicionar
          </a>
        </div>
      </div>
    </div>
  );
}
